import React from 'react'
import Wrapper from '../Wrapper'

const Services = (props) => {
  return (
    <Wrapper>
    <p>
    We provide a full range of a la carte services, including requirements
    gathering, design, programming, and testing; however we prefer to manage the
    complete life-cycle of the application.  Since, over time, much more time and
    effort will be spent on maintainance, our functional design process identifies
    those items which will require flexibility so we can build maintainability into the
    application.
    </p>
    <p>
    Any project worth doing is worth doing well, so we've spent a good deal of effort
    discovering the best practices in all phases of a project.  Time and budget must
    be balanced to yield the highest quality result.  A clear road map from start to
    finish works best, and both milestones and potential roadblocks should be identified
    from the start.  Hal Helms has written a brief but enlightening
    <a href="http://www.webreference.com/new/020103.html" > article called "Why Projects Fail" </a>
    and why some methodologies work better than others; we highly recommend it.
    </p>

    Call us in New York City at: 212.362.6362, or <a href="mailto:sales@cogdata.com">email</a>.
  </Wrapper>
  )
}

export default Services



// WEBPACK FOOTER //
// ./src/components/pages/Services.js